import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { LogoFull } from '@/components/LogoFull';
import { Button } from '@/components/ui/Button';

export function HomePage() {
    const { isAuthenticated, isLoading, needsOnboarding } = useAuth();

    return (
        <div className="flex min-h-screen flex-col bg-gray-50 dark:bg-dark">
            <main className="flex flex-1 items-center justify-center p-8">
                <div className="w-full max-w-sm text-center">
                    <a href="https://netfiscus.com" aria-label="Netfiscus website" className="mb-10 inline-block">
                        <LogoFull className="mx-auto h-10 w-auto" />
                    </a>

                    <h1 className="mb-3 text-2xl font-bold text-gray-900 dark:text-white">
                        Your net worth, in one place
                    </h1>
                    <p className="mb-8 text-gray-500 dark:text-gray-400">
                        Track your accounts, assets and debts, and see how they change over time.
                    </p>

                    {isLoading ? (
                        <Button className="w-full" size="lg" disabled>
                            Loading...
                        </Button>
                    ) : isAuthenticated ? (
                        <Link to={needsOnboarding ? '/onboarding' : '/dashboard'} className="block">
                            <Button className="w-full" size="lg">
                                {needsOnboarding ? 'Finish setup' : 'Go to dashboard'}
                            </Button>
                        </Link>
                    ) : (
                        <div className="space-y-3">
                            <Link to="/login" className="block">
                                <Button className="w-full" size="lg">
                                    Sign in
                                </Button>
                            </Link>
                            <Link to="/register" className="block">
                                <Button className="w-full" size="lg" variant="secondary">
                                    Create an account
                                </Button>
                            </Link>
                        </div>
                    )}
                </div>
            </main>

            <footer className="p-6 text-center text-sm text-gray-500 dark:text-gray-400">
                New to Netfiscus?{' '}
                <a
                    href="https://netfiscus.com"
                    className="font-medium text-gray-600 underline hover:no-underline dark:text-gray-300"
                >
                    Learn more
                </a>
            </footer>
        </div>
    );
}
